import { Zap } from "lucide-react";

/**
 * THE ONE PLACE the planning state of a visit is rendered (§2, 2026-09-07).
 *
 * Three states, and the third is silence on purpose:
 * - ad hoc:      `is_planned === false` with a `deviation_reason` — the officer
 *                said so and named why. Badge plus the reason.
 * - not in plan: `is_planned === false` with no reason — the server found no
 *                approved plan naming this doctor that day. Said quietly; it is
 *                a fact, not a fault.
 * - anything else: `true` (planned) or `null`/absent (a row written before the
 *                field existed — "not asked", never rewritten to "unplanned").
 *                Nothing is drawn: a gap is shown as a gap, not as a verdict.
 */
export default function AdHocBadge({ visit, size = "sm" }) {
  if (visit?.is_planned !== false) return null;
  const reason = visit.deviation_reason;
  const text = size === "lg" ? "text-xs" : "text-[11px]";
  if (!reason) {
    return (
      <span
        className={`inline-flex items-center gap-1 ${text} font-semibold text-callisto-muted`}
        data-testid={`visit-unplanned-${visit.id}`}
      >
        Not in plan
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-900 px-2 py-0.5 ${text} font-semibold`}
      data-testid={`visit-adhoc-${visit.id}`}
      title={reason}
    >
      <Zap size={size === "lg" ? 13 : 11} className="shrink-0" />
      Ad hoc · {reason}
    </span>
  );
}
